<template>
  <div>
    <b-card-body>
      <b-card class="user-password">
        <b-form submit.stop.prevent="save">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row>
            <b-col sm="12">
              <b-form-group v-if="user && user.role === 'GDI'" :label="$t('gdiAdherence')" label-for="aderencia-gdi">
                <b-form-input
                  class="input-pentagro"
                  id="aderencia-gdi"
                  type="number"
                  v-model="config.minimumGDIReability"
                  name="validateGdi"
                  v-validate="{
                    required: true,
                    numeric: false,
                    min_value: 0,
                    max_value: 100,
                  }"
                  :state="validateState('validateGdi')"
                  aria-describedby="validateGdi-feedback"
                  :data-vv-as="$t('gdiAdherence')"
                  :placeholder="$t('informe-a-aderencia-do-gdi')"
                />
                <b-form-invalid-feedback id="validateGdi-feedback">{{
                  veeErrors.first("validateGdi")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pgdiAdherence')" label-for="aderencia-pgdi">
                <b-form-input
                  class="input-pentagro"
                  id="aderencia-pgdi"
                  type="number"
                  v-model="config.minimumPGDIReability"
                  name="validatePgdi"
                  v-validate="{
                    required: true,
                    numeric: false,                    
                    min_value: 0,
                    max_value: 100,
                  }"
                  :state="validateState('validatePgdi')"
                  aria-describedby="validatePgdi-feedback"
                  :data-vv-as="$t('pgdiAdherenceMessage')"
                  :placeholder="$t('placeHolderpgdiAdherence')"
                />
                <b-form-invalid-feedback id="validatePgdi-feedback">{{
                  veeErrors.first("validatePgdi")
                }}</b-form-invalid-feedback>
              </b-form-group>

            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/salvar.png"
                alt="salvar"
                style="margin-left: 30px;"
                :title="$t('save')"
                @click="save"
              />
              <img
                src="@/assets/apagar.png"
                style="margin-left: 30px;"
                :title="$t('clear')"
                alt="limpar"
                @click="resetForm"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 20px;"
                :title="$t('exit')"
                alt="Sair"
                @click="$bvModal.hide('modalReliabilitySystem')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";


export default {
  name: "reliabilitySystem",
  computed: mapState(["user"]),
  data: function() {
    return {
      config: {
        minimumPGDIReability: 0,
        minimumGDIReability: 0,
        minimumOccurrenceAdherence: 0,
      },
      backupConfig: {}
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    save() {
      /* eslint-disable */
      this.$validator.validateAll().then(result => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        } else {   
          this.config.minimumGDIReability = parseFloat(this.config.minimumGDIReability)
          this.config.minimumPGDIReability = parseFloat(this.config.minimumPGDIReability)
          this.config.minimumOccurrenceAdherence = parseFloat(this.config.minimumOccurrenceAdherence)
          // console.log("Config: ", this.config);
          axios["post"](`${urlMainAPI}/savesystemconfiguration/`, this.config) //axios ... método chamado por string
            .then(res => {
              // console.log('ConfigAntesResetForm', this.config)
              this.$nextTick(() => {
                this.$validator.reset();
              });
              //this.$toasted.global.defaultSuccess();
              defaultSuccess(res.data);
              this.backupConfig = { ...this.config}
            })
            .catch(() => {
              this.resetForm();
            });
          // }
        }
      });
    },
    loadSystemConfig(){
      const url = `${urlMainAPI}/getsystemconfiguration`
      axios
      .get(url)
      .then(res => {
        this.config = res.data
        this.backupConfig = { ...res.data}
        this.$nextTick(() => {
          this.$validator.reset();
        });
        // console.log('ConfigSimulator', this.config) 
        // console.log('ConfigSimulator - Backup', this.backupConfig) 
      })
    },
    resetForm() {      
      this.$nextTick(() => {
        this.$validator.reset();
      });
      this.reset();    
    },
    reset() {
      this.config.minimumPGDIReability = this.backupConfig.minimumPGDIReability
      this.config.minimumGDIReability = this.backupConfig.minimumGDIReability
      this.config.minimumOccurrenceAdherence = this.backupConfig.minimumOccurrenceAdherence
    }
  },
  created() {
    this.$validator.localize("pt_BR");
    this.loadSystemConfig()
  }
};
</script>

<style scoped>
.user-password {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  cursor: pointer;
  max-height: 35px;
}
</style>
